<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="critereRecherche">
    <div class="column is-12 pdb-0"
         :class="[
      {'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('listeEcheancePaiement.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('listeEcheancePaiement.filtre.sousTitle') }}
        </span>
      </div>
      <div class="column is-12" v-if="errors.length > 0">
        <error-msg-component :messages="errors"
                             :error="errors.length > 0"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="errors = []"/>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless"
         :class="[
           {'hauteur-brief-filtre': errors.length === 0},
           {'hauteur-brief-filtre-errors': errors.length > 0}
         ]">
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeEcheancePaiement.filtre.modeReglement')">
          <qd-taginput v-if="modeReglementTags"
                      v-model="modeReglementSelected"
                      :data="modeReglementTags"
                      type="is-primary"
                      icon="magnify"
                      autocomplete
                      open-on-focus
                      field="libelle"
                      @typing="getFilteredModeReglementTags"
                      @input="getModeReglementTag">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeEcheancePaiement.filtre.payeur')">
          <qd-taginput
            v-model="payeursSelected"
            icon="magnify"
            :data="filteredPayeurs"
            autocomplete
            type="is-primary"
            :loading="isFetching"
            field="nomCommercial"
            @typing="getfilteredPayeurs">
            <template slot-scope="props">
            {{ props.option.nomCommercialAvecVille }}
            </template>
            <template slot="empty">
            <div v-if="!isFetching">
                {{$t('general.autocomplete.noRslt')}}
            </div>
            <div v-else>
                {{$t('general.autocomplete.search')}}
            </div>
            </template>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeEcheancePaiement.filtre.codeFacture')">
          <qd-taginput v-model="critereRecherche.factureCodes "
                      type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0 mgt-10px">
        <user-tag-input
                        :label="$t('listeEcheancePaiement.filtre.commercial')"
                        :blocked="userIsCommercialBlocked"
                        v-model="commercialSelected"
                        :items="listeCommercial">
        </user-tag-input>
        </div>
      <div class="column is-12 pdb-0 mgt-10px">
        <user-tag-input
                        :label="$t('listeEcheancePaiement.filtre.assistant')"
                        v-model="assistantSelected"
                        :items="listeAssistant">
        </user-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeEcheancePaiement.filtre.etat')">
          <b-select v-model="critereRecherche.paye">
            <option :value="null"></option>
            <option :value="true"> {{ $t('listeEcheancePaiement.paye') }}
            </option>
            <option :value="false"> {{ $t('listeEcheancePaiement.nonPaye') }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <libelle-tag-input
                        :label="$t('listeEcheancePaiement.filtre.natures')"
                        :items="constantes.LISTE_NATURE_REGLEMENT"
                        v-model="natureSelected">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <agence-tag-input
                      :label="$t('listeEcheancePaiement.filtre.agence')"
                      :items="agencesSelectionnees"
                      v-model="critereRecherche.agencesIds">
        </agence-tag-input>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('general.button.appliquer')}}
      </button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('general.button.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import messageErreur from '@/services/general/messageErreur';
import genererCritereRecherche
  from '@/services/echeancePaiement/genererCritereRechercheEcheancePaiement';
import {
  SET_CRITERE_RECHERCHE,
} from '@/store/modules/echeancePaiement-mutation-type';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { COMMERCIAL, DIRECTEUR_COMMERCIAL, ASSISTANT_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import { getAllByTradeName } from '@/api/tiers/index';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { TIERS_TYPE_CLIENT, TIERS_SOUS_TYPE_AUCUN } from '@/configuration/tiers/tiersConf';
import debounce from 'lodash/debounce';
import { LISTE_NATURE_REGLEMENT } from '@/configuration/remiseBancaire/remiseBancaireConf';
import userTagInput from '@/components/general/tagInput/userTagInput';
import initialUsers from '@/services/general/filters/filterinitUsers';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';

const Societe = createNamespacedHelpers('societe');
const EcheancesAPayer = createNamespacedHelpers('echeancePaiement');
const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');

export default {
  data() {
    return {
      critereRecherche: null,
      errors: [],
      listeModeReglementBase: [],
      modeReglementSelected: [],
      modeReglementTags: null,
      listeAssistant: [],
      assistantSelected: [],
      listeCommercial: [],
      commercialSelected: [],
      payeursSelected: [],
      isFetching: false,
      filteredPayeurs: [],
      constantes: {
        LISTE_NATURE_REGLEMENT,
      },
      natureSelected: [],
    };
  },
  components: {
    userTagInput,
    libelleTagInput,
    agenceTagInput,
    errorMsgComponent,
  },
  computed: {
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActiveId: 'societeActiveId',
    }),
    ...EcheancesAPayer.mapGetters({
      critereRechercheFromStore: 'criteresRecherche',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    modesReglement() {
      const modesReglement = this.parametre(PARAMETRES_KEYS.modeReglement);
      return modesReglement;
    },
    userIsCommercial() {
      return this.user.profil === COMMERCIAL;
    },
    userIsAssistant() {
      return (this.user.profil === ASSISTANT_COMMERCIAL);
    },
    filtrerParUtilisateur() {
      return this.parametresInterne(
        PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key,
      );
    },
    blocageFiltreCommercial() {
      return this.parametresInterne(
        PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
      );
    },
    userIsCommercialBlocked() {
      return (this.userIsCommercial && this.blocageFiltreCommercial);
    },
  },
  methods: {
    ...EcheancesAPayer.mapMutations({
      setCritereRecherche: SET_CRITERE_RECHERCHE,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametresInterne: 'loadParametresInterne',
    }),
    viderCritere() {
      this.critereRecherche = cloneDeep(genererCritereRecherche());
      this.modeReglementSelected = [];
      this.assistantSelected = [];
      this.commercialSelected = [];
      this.payeursSelected = [];
      this.natureSelected = [];
      if (this.filtrerParUtilisateur && this.userIsCommercial) {
        this.critereRecherche.commercialId.push(this.user.id);
        this.commercialSelected = this.listeCommercial.filter((c) => {
          return this.user.id === c.id;
        });
      }
      if (this.filtrerParUtilisateur && this.userIsAssistant) {
        this.critereRecherche.assistantIds.push(this.user.id);
        this.assistantSelected = this.listeAssistant.filter((a) => {
          return this.user.id === a.id || a.id === null;
        });
      }
      if (this.critereRecherche.natures) {
        this.natureSelected = this.constantes.LISTE_NATURE_REGLEMENT.filter((e) => {
          return this.critereRecherche.natures.includes(e.code);
        });
      }
      this.getModeReglementTag();
    },
    appliquerCritere() {
      if (this.critereRecherche.datesMouvement.dateFin
        && this.critereRecherche.datesMouvement.dateDebut
        > this.critereRecherche.datesMouvement.dateFin) {
        this.errors.push({
          message: 'listeEcheancePaiement.filtre.errors.dateDebutGreaterDateFin',
        });
      }
      if (this.errors.length > 0) return;
      this.critereRecherche.modesReglementsIds = this.modeReglementSelected.map((modeReglement) => {
        return modeReglement.id;
      });
      this.critereRecherche.assistantIds = this.assistantSelected.map((a) => {
        return a.id;
      });
      if (this.commercialSelected) {
        this.critereRecherche.commercialIds = this.commercialSelected.map((c) => {
          return c.id;
        });
      }
      this.critereRecherche.payeurIds = this.payeursSelected.map((p) => {
        return p.id;
      });
      this.critereRecherche.natures = this.natureSelected
        .map((e) => {
          return e.code;
        });
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche');
    },
    getModeReglementTag() {
      this.modeReglementTags = this.listeModeReglementBase.filter((modeReglement) => {
        return !this.modeReglementSelected.map(a => a.id).includes(modeReglement.id);
      });
    },
    getFilteredModeReglementTags(text) {
      this.getModeReglementTag();
      this.modeReglementTags = this.modeReglementTags.filter((modeReglement) => {
        return modeReglement.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getfilteredPayeurs: debounce(async function getPayeurs(search) {
      this.filteredPayeurs = [];
      if (!search) return;
      this.isFetching = true;
      try {
        const payeurs = (await getAllByTradeName(
          search, this.societeActiveId, TIERS_TYPE_CLIENT, [TIERS_SOUS_TYPE_AUCUN],
        )).data.result.items;
        payeurs.forEach((payeur) => {
          payeur.nomCommercialAvecVille = payeur.code + ' - ' + payeur.nomCommercial;
          if (payeur.adressePostale && payeur.adressePostale.ville) {
            payeur.nomCommercialAvecVille += ' - ' + adressFullStringGetter(payeur.adressePostale, false);
          }
          if (payeur.compteComptable) {
            payeur.nomCommercialAvecVille += ' - ' + payeur.compteComptable;
          }
        });
        this.filteredPayeurs = payeurs.filter((payeur) => {
          return !this.payeursSelected.map(
            payeursSelected => payeursSelected.id,
          ).includes(payeur.id);
        });
        this.isFetching = false;
      } catch (e) {
        this.isFetching = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    async initializeFiltre() {
      this.critereRecherche = cloneDeep(this.critereRechercheFromStore);
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadParametreUtilisateur();
        await this.loadParametres([PARAMETRES_KEYS.modeReglement]);
        await this.loadParametresInterne([
          PARAMETRES_INTERNE_KEYS.blocageFiltreCommercial.key,
          PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key]);
        this.listeModeReglementBase = this.modesReglement;
        if (this.critereRecherche.modesReglementsIds.length > 0) {
          this.modeReglementSelected = this.listeModeReglementBase.filter((modeReglemnt) => {
            return this.critereRecherche.modesReglementsIds.includes(modeReglemnt.id);
          });
        }
        this.getModeReglementTag();

        const users = this.parametre(PARAMETRES_KEYS.utilisateur).filter(u => u.actif);

        this.listeAssistant = initialUsers(users, [ASSISTANT_COMMERCIAL], this.$i18n.t('listeEcheancePaiement.filtre.noAssistant'));
        this.listeCommercial = initialUsers(users, [DIRECTEUR_COMMERCIAL, COMMERCIAL], this.$i18n.t('listeEcheancePaiement.filtre.noCommercial'));

        this.natureSelected = this.constantes.LISTE_NATURE_REGLEMENT.filter((e) => {
          return this.critereRecherche.natures.includes(e.code);
        });
        this.assistantSelected = this.listeAssistant.filter((a) => {
          return this.critereRecherche.assistantIds.includes(a.id);
        });
        this.commercialSelected = this.listeCommercial.filter((c) => {
          return this.critereRecherche.commercialIds.includes(c.id);
        });

        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw (e);
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
